<script setup lang="ts">
import { AccordionList, AccordionItem } from 'vue3-rich-accordion'

const { isMobile_lg } = useWindowWidth()
const contentKey = ref(0)

const { locale } = useI18n()
const pageFaqSection = inject<Ref<ICMSLocationContent>>('pageFaqSection')!
const sectionContent = ref<ICMSLocationContentTranslations>(
	pageFaqSection.value?.translations.find((translation) => translation.language === locale.value)?.content,
)

defineProps<{
	pageTitle: string
}>()

const filledFaqs = computed(() => sectionContent.value?.filter((faq) => faq.question && faq.answer) ?? [])

const isAtleastOneFaqFilled = computed(() => filledFaqs.value.length > 0)

useFaqJsonld(() => sectionContent.value as unknown as IFaqQuestion[])

onMounted(() => {
	// rerender content, v-html seems not to work in accordion
	contentKey.value++
})
</script>

<template>
	<section v-if="isAtleastOneFaqFilled" class="car-rental-faq">
		<div class="car-rental-faq__title-wrapper">
			<div class="car-rental-faq__title-box">
				<h2 class="car-rental-faq__title">
					{{ $t('modules.car_rental_module.car_rental.faq.title', { page: pageTitle }) }}
				</h2>
			</div>
		</div>
		<AccordionList class="car-rental-faq__accordion">
			<AccordionItem v-for="(item, idx) in filledFaqs" :key="idx" class="car-rental-faq__item" :defaultOpened="false">
				<template #summary>
					<div class="car-rental-faq__item-summary">
						<h3>{{ item.question }}</h3>
					</div>
				</template>
				<template #icon><GlobalIcon name="accordion-icon" :width="isMobile_lg ? 24 : 32" :height="isMobile_lg ? 24 : 32" /></template>
				<p :key="contentKey" class="car-rental-faq__item-description rich-text rich-text--compact" v-html="item.answer"></p>
			</AccordionItem>
		</AccordionList>
	</section>
</template>

<style lang="scss">
@use '@/assets/scss/components/accordion';
</style>
<style lang="scss" scoped src="./Faq.scss"></style>
